// extracted by mini-css-extract-plugin
export default {"model":"Model_model__fupNx","model__view":"Model_model__view__lfveY"};